export const buildParameter = {
    ExecuteQuery:(SqlQuery,pagelimit,pageindex,sortorder, sortfield,tablechange) =>{
        
        let param = {
            sqlQuery: SqlQuery,
            pageLimit: pagelimit,
            pageIndex: pageindex,
            sortOrder: sortorder,
            sortField: sortfield,
            tableChange: tablechange
        };
       // console.log(param);
        return param;
    },
    SaveConnect: (hostKey,hostName,backUpServer,DBPort,formdata,hostTitle) => {
        //console.log(formdata);
        let param = {
            hostKey: hostKey.trim(),
            hostTitle: hostTitle.trim(),
            hostName: hostName.trim(),
            userName: formdata.UserName.trim(),
            passWord: formdata.Password.trim(),
            dataBase: formdata.Database.trim(),
            backupServer :backUpServer,
            dbPort: DBPort,
        };
        return param;
    },
    GetListTable:() =>{
        let param = {
            sqlQuery: '',
        };
        return param;
    },
    ExportAll:(SqlQuery,QueryName,FileType) =>{
        
        let param = {
            sqlQuery: SqlQuery,
            queryName: QueryName,
            fileType: FileType
        };
        //console.log(param);
        return param;
    },
};
